/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {LinkContainer} from 'react-router-bootstrap';
import {ListGroup, ListGroupItem, PanelGroup, Panel} from 'eui-components';
import scrollIntoView from 'scroll-into-view-if-needed';

import styles from './DomainApplicationMenu.css';

export class DomainApplicationMenu extends Component {
  static propTypes = {
    applications: PropTypes.array.isRequired,
    active: PropTypes.shape({
      application: PropTypes.string,
      page: PropTypes.string
    }).isRequired,
    onSelectMenuItem: PropTypes.func.isRequired
  };

  static defaultProps = {
    applications: [],
    active: {
      application: null,
      page: null
    }
  };

  render() {
    return (
        <PanelGroup accordion id='application-menu' activeKey={this.props.active.application}
                    onSelect={this.handleSelect} className={styles.applicationMenuPanelGroup}>
          {this.props.applications.map((application) =>
              <Panel key={application.id} eventKey={application.id} id={`${application.id}Panel`}>
                <Panel.Heading>
                  <Panel.Title toggle>{application.label}</Panel.Title>
                </Panel.Heading>
                <Panel.Collapse onEntered={this.onEntered}>
                  <Panel.Body>
                    <ListGroup>
                      {application.links.map((link) => {
                        return (
                            <LinkContainer
                                to={{
                                  pathname: `/apps${link.uri}`,
                                  search: this.props.contextInstitution && `?registryid=${this.props.contextInstitution}`,
                                  state: {pageId: link.id, applicationId: application.id}
                                }}
                                id={`application-menu-${application.id}-${link.id}`}
                                key={`${link.uri}-${link.label}`} isActive={() => link.id === this.props.active.page}>
                          <ListGroupItem onClick={(e) => { this.navigateTo(application, link, e); }}>
                                {link.label}
                              </ListGroupItem>
                            </LinkContainer>
                        );
                      })
                      }
                    </ListGroup>
                  </Panel.Body>
                </Panel.Collapse>
              </Panel>
          )}
        </PanelGroup>
    );
  }

  onEntered = (elem) => {
    elem = elem.parentElement;
    this.scrollElementIntoView(elem);
  };

  scrollElementIntoView = (elem) => {
    scrollIntoView(elem, {
      block: 'start',
      inline: 'nearest',
      behavior: 'smooth',
      scrollMode: 'if-needed',
      boundary: document.getElementById('application-menu'),
    });
  }

  handleSelect = (activeKey) => {
    this.props.onSelectMenuItem({applicationId: activeKey});
  };

  navigateTo = (application, link, e) => {
    this.props.onSelectMenuItem({applicationId: application.id, pageId: link.id});
  }
}



// WEBPACK FOOTER //
// ./src/DomainApplicationView/DomainApplicationMenu.js